<template>
  <textarea class="textarea" :class="{ isError: error }" v-model="_value" />
</template>

<script>
import autosize from 'autosize'

/**
 * テキストエリア
 *
 * [autosize](https://github.com/jackmoore/autosize) により自動でサイズが変わります
 */
export default {
  name: 'TextArea',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    /** 値 (v-model) */
    value: String,
    /** 自動サイズ調整なし */
    noneAutosize: Boolean,
    /** エラー表示 */
    error: Boolean,
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(value) {
        /**
         * 値の変更 (v-model)
         * @event input
         */
        this.$emit('input', value)
      },
    },
  },
  async mounted() {
    if (this.noneAutosize) return
    await this.$nextTick()
    autosize(this.$el)
  },
}
</script>

<style lang="postcss" scoped>
.textarea {
  appearance: none;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  box-sizing: border-box;
  color: var(--text-color);
  display: inline-block;
  font-size: 15px;
  min-height: 40px;
  outline: 0;
  padding: 12px 16px;
  resize: vertical;
  width: 100%;

  &:focus {
    border: 1px solid var(--dark-gray);
  }

  &:disabled {
    background-color: var(--mostly-white-1);
  }

  &::placeholder {
    color: var(--dark-gray);
  }

  &.isError:not(:disabled) {
    background: #fff3f0;
    border: 1px solid var(--pure-red);
  }
}
</style>
